import React, { useState, useEffect } from 'react';
import Button from '../Button';
import PhoneInputAction from "../../module/common/PhoneInput/action";


import { ModalPC } from "@mail/ui.modal";
import { useWhichEnd } from '@mail/m-hooks';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router';
import { Overlay } from "@mail/easyui.overlay";
import { ReactComponent as CloseSvg } from "./imgs/close.svg";

import "@mail/ui.theme";


// 动态导入样式
if (process.env.MAIL_APP_PLATFORM === 'h5') {
    require('./style_h5.scss')
} else {
    require('./style.scss')
}

export interface ISafePhoneGradeConfirm {
    visible: boolean;
    safePhone: string;
    onVisible: (visible: boolean) => void;
};


const SafePhoneGradeConfirm: React.FC<ISafePhoneGradeConfirm> = ({
    visible,
    safePhone,
    onVisible,
}) => {
    const whichEnd = useWhichEnd();
    const dispatch = useDispatch();
    const history = useHistory();
    const [isPickerVisible, setIsPickerVisible] = useState(false);

    // 使用 useCallback 缓存回调函数
    const fillMoreFDataHandle = async () => {
        try {
            dispatch({
                type: PhoneInputAction.UPDATE_PHONE_GROUP,
                playload: {
                    phoneType: { id: "+86", name: "+86" },
                    phoneNumber: safePhone,
                }
            });
            dispatch({
                type: PhoneInputAction.UPDATE_SHOW_SMS_BOX,
                playload: {
                    showBox: true,
                }
            });
            history.replace({
                pathname: whichEnd.h5 ? '/dataReviewOtherInfo' : '/dataReview'
            });
        } catch (error) {
            console.error('检查安全手机等级失败:', error);
        } finally {
            onVisible(false);
        }
    };

    useEffect(() => {
        setIsPickerVisible(visible);
    }, [visible]);

    if (!!whichEnd.h5) {
        return (
            <Overlay
                active={visible}
                position="bottom"
            >
                <div className='safe-phone__confirm'>
                    <CloseSvg className='safe-phone__confirm-close' onClick={() => onVisible(false)} />
                    <div className='safe-phone__confirm-title'>收到您提交的身份信息</div>
                    <div className='safe-phone__confirm-content'>
                        还需要您补充更多邮箱使用相关信息，以便完成验证
                    </div>
                    <Button
                        text="去填写"
                        color="primary"
                        extraClass="safe-phone__confirm-button"
                        onClick={fillMoreFDataHandle}
                    />
                </div>
            </Overlay>
        );
    }


    return (
        //@ts-ignore
        <ModalPC
            visible={isPickerVisible}
            title="收到您提交的身份信息"
            mask={false}
            width={480}
            content="还需要您补充更多邮箱使用相关信息，以便完成验证"
            onCancel={() => onVisible(false)}
            footer={<Button
                text="去填写"
                color='primary'
                extraClass="safe-phone__confirm-button"
                onClick={fillMoreFDataHandle}
            />}
        />
    );
};

export default SafePhoneGradeConfirm;